import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Button, CircularProgress } from '@material-ui/core'
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { TextMaskCustom } from '../../components/MaskedInput'
import { updateUserPut, updateUser, getUser } from '../../actions/users'
import LicenseImageUpload from '../LicenseImageUpload';
import { uploadImage } from "../../actions/avatarImage"
import BuyerOrgHeader from '../BuyerOrgHeader';
import { openSnackBar } from '../../actions/snack-bar'

const byId = id => {
  return document.getElementById(id).value
}

class BuyerProfile extends React.Component {

  state = {
    first_name: '',
    last_name: '',
    phone: '',
    isEditMode: false,
    spin: false,
    photoID: '',
    imageObject: ''
  }

  componentDidMount() {
    this.getUser();
  }

  getUser = () => {
    this.props.dispatch(
      getUser(this.props.authentication.authenticatedUser.id, true)
    ).then(res => {
      if (res.photo_id) {
        const { secure_url } = JSON.parse(res.photo_id)
        this.setState({ photoID: secure_url });
      }
    })
  }

  editDetails = (bool) => {
    this.setState({ isEditMode: bool });
    if (!bool) {
      this.getUser()
    }
  }

  doUpdate = e => {
    e.preventDefault()

    if (byId('first_name').trim().length < 1) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter a first name'
        })
      )
      return
    } else if (byId('last_name').trim().length < 1) {
      this.props.dispatch(
        openSnackBar({
          message: 'Please enter a last name'
        })
      )
      return
    }
    const newData = {
      first_name: byId('first_name').trim(),
      last_name: byId('last_name').trim(),
      phone: byId('phone').replace(/\D/g, '')
    }
    this.props.dispatch(
      updateUserPut(
        this.props.authentication.authenticatedUser.id,
        newData,
        this.props.history,
        'buyer',
        (response) => {
          this.setState({ isEditMode: false });
        }
      )
    )
  }

  onDrop = file => {
    this.setState({ spin: true })
    this.props.dispatch(
      uploadImage(file.target.files[0], "licensePhoto", (res) => {
        const { secure_url } = JSON.parse(res.photo_id)
        this.setState({ photoID: secure_url || '', spin: false, imageObject: res.photo_id });
        const newData = { photo_id: res.photo_id }
        this.updateUserProfile(newData);
      })
    )
  }

  updateUserProfile = (data) => {
    this.props.dispatch(
      updateUser(
        this.props.authentication.authenticatedUser.id,
        data
      )
    )
  }
  render() {
    const { classes, authentication = {} } = this.props
    const { authenticatedUser = {} } = authentication
    const {
      first_name = '',
      last_name = '',
      phone = '',
    } = authenticatedUser;
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open = Boolean(anchorEl);

    // function handleClose() {
    //   setAnchorEl(null);
    // }
    return (
      <div className={classes.mainContainer}>
        {/* {this.state.isEditMode && <ChangePasswordModal/>} */}
        <BuyerOrgHeader authentication={this.props.authentication} />
        <Grid container>
          <Paper className={classes.profileContainer}>
            <Typography variant="h3" gutterBottom className={classes.profileHeading}>
              My Profile
            </Typography>
            <Divider />
            <Grid container>
              <Grid item xs={12} sm={6} className="profile-inputs">
                <Typography variant="h5" gutterBottom className={classes.profileSubHeading}>
                  Basic Information
                </Typography>
                <TextField
                  disabled={!this.state.isEditMode}
                  id="first_name"
                  label="First Name"
                  defaultValue={first_name}
                  className={classes.profileTextField}
                  margin="normal"
                />
                <TextField
                  disabled={!this.state.isEditMode}
                  id="last_name"
                  label="Last Name"
                  defaultValue={last_name}
                  className={classes.profileTextField}
                  margin="normal"
                />
                <TextField
                  disabled
                  name="phone"
                  id="phone"
                  value={phone.slice(2)}
                  label="Mobile Number"
                  type="tel"
                  className={classes.profileTextField}
                  margin="normal"
                  InputProps={{ inputComponent: TextMaskCustom }}
                />
              </Grid>
              <Grid item xs={12} sm={6} className="image-upload-section">
                <Typography variant="h5" gutterBottom className={classes.profileSubHeading}>
                  Document
                </Typography>
                < LicenseImageUpload onDrop={this.onDrop} photoID={this.state.photoID} spin={this.state.spin} isViewProfile={!this.state.isEditMode} showLicenseText={true} />
              </Grid>
              {!this.state.isEditMode && <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.editDetails(true)}
                  className={classes.editProfileButton}
                >
                  Edit profile
                </Button>
              </Grid>}
              {this.state.isEditMode && <Fragment><Grid item xs={12} style={{ textAlign: 'center' }}>
                <Button
                  disabled={this.props.updatingUser}
                  variant="contained"
                  color="primary"
                  onClick={this.doUpdate}
                  className={classes.editProfileButton}
                >
                  Save Changes
                </Button>
                <Button
                  color="secondary"
                  onClick={() => this.editDetails(false)}
                  className={classes.editProfileButton}
                >
                  Cancel
                </Button>
              </Grid></Fragment>}
            </Grid>
          </Paper>
        </Grid>
        <Grid container>
          <p className={classes.footerText}>@2019 SafeShowings. All Right Reserved</p>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser
  }
}
const mapActionsToProps = dispatch => {
  return {
    dispatch
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(BuyerProfile)
